// extracted by mini-css-extract-plugin
export default {"prompt-main":"PromptSection_prompt-main__OUd-C","prompt":"PromptSection_prompt__biseq","is-selected":"PromptSection_is-selected__fScoa","icon":"PromptSection_icon__WxtQd"};